import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { BaseFiltroPaginate } from "core/resources/enums/paginate";
import { TenantPaginateResponse } from "core/features/tenants/typings/tenant";

function useClientes({
  page = 1,
  limit = BaseFiltroPaginate.Limit,
  search = undefined,
  tenant = undefined,
}: PaginateQuery & { tenant?: string }) {
  return useQuery([`/v1/clientes-tenant-${page}-${limit}-${search}`], async () => {
    const res = await axios.get<PaginateResult<TenantPaginateResponse>>(
      "/v1/clientes-tenant",
      {
        params: {
          page,
          limit,
          search,
        },
      }
    );

    return res.data;
  });
}

export default useClientes;
